import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-467b9b71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "About Me")
], -1))
const _hoisted_3 = { id: "Bio" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div data-v-467b9b71><h1 data-v-467b9b71> Hrishikesh Karale </h1><h3 data-v-467b9b71> Product Designer </h3><h5 data-v-467b9b71> Sr. UX Designer/Developer </h5><div class=\"social\" data-v-467b9b71><a target=\"_blank\" href=\"https://github.com/HrishikeshKarale\" data-v-467b9b71><span class=\"fab fa-github\" data-v-467b9b71></span></a><a target=\"_blank\" href=\"https://www.npmjs.com/~kkiokio\" data-v-467b9b71><span class=\"fab fa-npm\" data-v-467b9b71></span></a><a target=\"_blank\" href=\"https://www.linkedin.com/in/hrishikesh-karale/\" data-v-467b9b71><span class=\"fab fa-linkedin-in\" data-v-467b9b71></span></a></div><a href=\"../../assets/Hrishikesh Karale-Resume.pdf\" download data-v-467b9b71> Resume </a></div>", 1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p data-v-467b9b71> I have a <mark data-v-467b9b71>Masters in Human Computer Interaction and Design</mark> and a <mark data-v-467b9b71>Bachelors in Computer Engineering</mark>, this allows me to take development into consideration when designing a solution. </p><p data-v-467b9b71> As a UX Professional, I strive to use a constant end-user feedback loop to define and redefine my project objectives. The user&#39;s needs guide the strategic decisions I make during my UX process. This non-linear approach is integral to ensuring that my projects decisions lead to a massive improvement in the key metrics that are relevant to the user experience. In short, I like to think like an engineer in addition to being a UX Professional. </p><p data-v-467b9b71> I’m also a novice visual designer. I’ve designed over 30 working prototypes in online-shopping, warehouse-management, inventory-management, fulfillment and healthcare using a multitude of prototyping tools including products such as <mark data-v-467b9b71>Illustrator</mark>, <mark data-v-467b9b71>Adobe XD</mark>, <mark data-v-467b9b71>Sketch</mark> and <mark data-v-467b9b71>Figma</mark>. My prototyping strategy primarily focuses on functionality and usability. </p>", 3)
const _hoisted_8 = { id: "Process" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "My Process"),
  /*#__PURE__*/_createElementVNode("h3", null, "Steps I take to assure success")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " One of the key factors that define a designers work is the process they use to solve a problem. ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " With time, my process evolved from a standard 5 step prcoess (define, research, ideate, prototype, Test) to a 8 step process where each step signifies a milestone for the projects. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Each of the 8 steps are further divided into various sub-steps that help add value and help us achieve out goals towards the process. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, " Note: The steps followed depends on the timeline and project requirements and ")
], -1))
const _hoisted_14 = { class: "process" }
const _hoisted_15 = { class: "steps" }
const _hoisted_16 = { class: "step" }
const _hoisted_17 = { class: "step-title" }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { id: "Skillset" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Skill Set"),
  /*#__PURE__*/_createElementVNode("h3", null, "Badges on my belt")
], -1))
const _hoisted_21 = { class: "subSection" }
const _hoisted_22 = { id: "LisencesAndCertificates" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Licenses & Certificates")
], -1))
const _hoisted_24 = { class: "subSection" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Issued ", -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Credential ID ", -1))
const _hoisted_29 = { id: "honorsAndAwards" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Honors & Awards")
], -1))
const _hoisted_31 = { class: "subSection" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Issued ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_img = _resolveComponent("vue-img")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_vue_img, {
          src: _ctx.PROFILEPIC,
          alt: "Hrishikesh Karale profile Picture"
        }, null, 8, ["src"]),
        _hoisted_4
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", null, " I have " + _toDisplayString(_ctx.EXPERIENCE.academic) + " years of academic and " + _toDisplayString(_ctx.EXPERIENCE.professional) + "+ years of experience working on several major software projects in the eCommerce and Enterprise domain. ", 1),
        _hoisted_5
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("ol", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uxProcess, (step, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(step.title), 1),
              _createElementVNode("h4", _hoisted_17, _toDisplayString(step.subTitle), 1),
              _createElementVNode("ol", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.skills, (skill) => {
                  return (_openBlock(), _createElementBlock("li", { key: skill }, [
                    _createElementVNode("small", {
                      textContent: _toDisplayString(skill)
                    }, null, 8, _hoisted_18)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("ol", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillset, (skill) => {
          return (_openBlock(), _createElementBlock("li", {
            key: skill.type
          }, [
            _createElementVNode("h4", null, _toDisplayString(skill.type), 1),
            _createElementVNode("ol", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.value, (value) => {
                return (_openBlock(), _createElementBlock("li", { key: value }, _toDisplayString(value), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_22, [
      _hoisted_23,
      _createElementVNode("ol", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lisencesAndCertificates, (cert) => {
          return (_openBlock(), _createElementBlock("li", {
            key: cert.id
          }, [
            _createVNode(_component_vue_img, {
              src: cert.link,
              alt: cert.id + ' - ' + cert.link
            }, null, 8, ["src", "alt"]),
            _createElementVNode("h4", null, [
              _createTextVNode(_toDisplayString(cert.title) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(cert.issuer), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", null, [
                _hoisted_25,
                _createTextVNode(" " + _toDisplayString(cert.issued), 1)
              ]),
              (cert.expiry)
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                    _createElementVNode("b", null, _toDisplayString(cert.expiry), 1)
                  ]))
                : _createCommentVNode("", true),
              (cert.credential)
                ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                    _hoisted_28,
                    _createTextVNode(" " + _toDisplayString(cert.credential), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_29, [
      _hoisted_30,
      _createElementVNode("ol", _hoisted_31, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.honorsAndAwards, (award) => {
          return (_openBlock(), _createElementBlock("li", {
            key: award.id
          }, [
            _createVNode(_component_vue_img, {
              src: award.link,
              alt: award.id + ' - ' + award.link
            }, null, 8, ["src", "alt"]),
            _createElementVNode("h4", null, [
              _createTextVNode(_toDisplayString(award.title) + " ", 1),
              _createElementVNode("small", null, _toDisplayString(award.issuer), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", null, [
                _hoisted_32,
                _createTextVNode(" " + _toDisplayString(award.issued), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}